module.exports = __webpack_public_path__ + "img/mission.0d498e34.png";